import { memo } from 'react';
import { withStyles } from '@material-ui/core';
import CountSelector from './CountSelector';

const style = ({ spacing }) => ({
    mobileTitle: {
        paddingRight: spacing(1),
    },
});

export default withStyles(style)(memo(CountSelector));
